import React from "react";
import { Grid, InputAdornment, TextField, Typography } from "@material-ui/core";

import "./style.css";

const FormTextInput = ({
  id,
  name,
  label = "",
  required,
  errorText,
  value,
  placeholder = "",
  className = "",
  multiline = false,
  icon,
  iconPosition = "start",
  maxLength,
  onChangeInput = () => {},
}) => {
  const inputIcon = icon && (
    <InputAdornment position={iconPosition}>{icon}</InputAdornment>
  );

  return (
    <Grid
      container
      direction="column"
      className={`form-text-input gap-y-8 ${className}`}
    >
      <Typography variant="body2" className="form-label">
        {label}
        {required && <span> *</span>}
      </Typography>

      <TextField
        id={id}
        name={name}
        variant="outlined"
        multiline={multiline}
        placeholder={placeholder}
        value={value}
        onChange={onChangeInput}
        inputProps={{ maxLength }}
        InputProps={{
          maxLength: 5,
          ...(iconPosition === "start" && {
            startAdornment: inputIcon,
          }),
          ...(iconPosition === "end" && {
            endAdornment: inputIcon,
          }),
        }}
      />

      {errorText && (
        <Typography variant="caption" className="error-text">
          {errorText}
        </Typography>
      )}
    </Grid>
  );
};

export default FormTextInput;
